/*
  •	Copyright (c) 2023 Pegasystems Inc.
  •	All rights reserved.
*/
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { logAndCatchError } from '../../utils/rxjs-utils';
import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { ACTION_GETDESCENDANTS } from '../../store/state/actions';
import { processHeaders } from '../../store/state/epics/util';
import HeaderProcessor from '../../service_broker/header-processor';
import type { Action } from '../../store/state/state-manager';

const GET_DESCENDANTS_DXAPI_LOG_ERROR_MESSAGE = 'Error ocurred during ajax call at getDescendants Epic : ';

export const executeGetDescendantsRequest = (actionInPayload: Action['payload']) => {
  const { caseID, headers, debugInfo, context } = actionInPayload;
  const restApiDetails = resolveRestApi(ACTION_GETDESCENDANTS, {
    caseID
  });
  const { restApi } = restApiDetails;
  const { reqType } = restApiDetails;

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          ...(debugInfo && { ...HeaderProcessor.addDebugHeaders(debugInfo) })
        },
        skipClearErrorMessages: true
      },
      context
    )
  ).pipe(
    map((response) => {
      return {
        actionInPayload,
        response: response.data,
        headers: processHeaders({ ...headers, ...response.headers })
      };
    }),
    logAndCatchError(GET_DESCENDANTS_DXAPI_LOG_ERROR_MESSAGE, context)
  );
};

export default executeGetDescendantsRequest;
